import * as React from "react"
import {Grid} from "@mui/material";

import {repricingAlertsFiltered} from "../../@signals";
import {useRepricingAlerts} from "../@hooks";
import RepricingAlertsLoadingBlock from "./LoadingBlock";
import RepricingNewAlertButton from "./NewAlertButton";
import RepricingAlertCard from "./AlertCard";


export default function RepricingAlertsBlock() {
    const { isLoadingAlerts } = useRepricingAlerts()

    return <>
        { !!isLoadingAlerts && <RepricingAlertsLoadingBlock /> }
        { !isLoadingAlerts && <>
            <Grid item xs={3}>
                <RepricingNewAlertButton />
            </Grid>

            { repricingAlertsFiltered.value.map((alert, idx) => <Grid item xs={3} key={idx}>
                <RepricingAlertCard {...alert} idx={idx} />
            </Grid>) }
        </> }
    </>
}